import Vue from 'vue';
import moment from 'moment';

Vue.filter('dateTime', function (value) {
  return value ? moment(value)
    .format('Y. MM. DD. HH:mm') : '';
});

Vue.filter('date', function (value) {
  return value ? moment(value)
    .format('Y. MM. DD.') : '';
});

Vue.filter('shortDate', function (value) {
  return value ? moment(value)
    .format('MM. DD.') : '';
});
